import { Box } from '@chakra-ui/react';
import { CancelOrder } from '@diamond/shared/types';

import { ReasonAlertBox } from './ReasonAlertBox';
import { ReasonAlertItem } from './types';
import { groupItemsByReason } from './utils';

export interface CancelledOrdersSectionProps {
  cancelOrders: CancelOrder[];
}

/**
 * Displays items cancelled BEFORE DO creation
 * Shows red alert box with cancellation reason (e.g., "Stok habis")
 */
export function CancelledOrdersSection({
  cancelOrders,
}: CancelledOrdersSectionProps) {
  if (!cancelOrders || cancelOrders.length === 0) {
    return null;
  }

  const mappedItems: ReasonAlertItem[] = cancelOrders.map((item) => ({
    product_name: item.product_name,
    quantity: item.quantity,
    sales_unit: item.sales_unit,
  }));
  const reasons = cancelOrders.map((item) => item.cancel_reason);
  const groupedByReason = groupItemsByReason(mappedItems, reasons);

  return (
    <Box py={2} data-testid="cancelled-orders-section">
      <ReasonAlertBox groupedItems={groupedByReason} />
    </Box>
  );
}
